import {useRouter} from 'next/router';
import {ReactElement} from 'react';
import {
  Twitter as TwitterIcon,
  GitHub as GitHubIcon,
  YCombinator as YCombinatorIcon,
  Reddit as RedditIcon,
} from '@polarsignals/icons';

const getSocialIcon = (link: string) => {
  let icon: ReactElement | null = null;
  if (link.startsWith('https://twitter.com/')) {
    icon = <TwitterIcon height={30} />;
  }
  if (link.startsWith('https://github.com/')) {
    icon = <GitHubIcon height={22} />;
  }
  if (link.startsWith('https://news.ycombinator.com/')) {
    icon = <YCombinatorIcon width={30} height={30} />;
  }
  if (link.startsWith('https://www.reddit.com/')) {
    icon = <RedditIcon width={30} height={30} />;
  }
  if (icon) {
    return (
      <div className="mx-4" key={link}>
        <a href={link} target="_blank" rel="noreferrer">
          {icon}
        </a>
      </div>
    );
  }
  return null;
};

const SocialInteractionPrompts = ({
  hnLink = '',
  redditLink = '',
  title,
}: {
  hnLink: string;
  redditLink: string;
  title: string;
}) => {
  const router = useRouter();
  const postURL = encodeURIComponent(`https://www.polarsignals.com${router.route}`);

  const tweetText = encodeURIComponent(
    `${title} via @PolarSignalsIO https://www.polarsignals.com${router.route}`
  );
  const tweetLink = `https://twitter.com/intent/tweet?text=${tweetText}`;

  return (
    <div className="justify-left mt-16 flex items-center text-sm">
      <span className="mr-4 text-xl">Discuss:</span>
      {getSocialIcon(hnLink || `https://news.ycombinator.com/submitlink?u=${postURL}&t=${title}`)}
      {getSocialIcon(tweetLink)}
      {getSocialIcon(redditLink || `https://www.reddit.com/submit?url=${postURL}&title=${title}`)}
    </div>
  );
};

export default SocialInteractionPrompts;
